import React from "react";
import CallMe from "../../component/Common/CallMe";
import FormPartner from "../../component/Common/FormRegisterPartner";
import HeaderPartner from "../../component/Common/HeaderPartner";
import NavBar from "../../component/Common/Navbar";
import FooterCloud from "../../component/LandingPage/Footer";
import TablePriceReseller from "../../component/ResellerPage/TablePrice";
import WhyJoinReseller from "../../component/ResellerPage/WhyJoinReselelr";
import Head from "next/head";

const Reseller = () => {
  const title = "Daftar Cloudbank reseller sekarang juga";
  const description =
    "Dengan bergabung di Cloudbank reseller, Anda akan mendapatkan harga khusus, prioritas support admin dan berbagai kemudahan lain untuk mengelola website client Anda";
  const headerTitle = "Cloudbank Reseller";
  const headerDescription =
    "Gabung sekarang untuk membuat bisnis web hosting Anda menjadi lebih profesional dan dapatkan fitur integrasi user management, white label invoice dan markup dengan harga yang jauh lebih murah";
  return (
    <div>
      {/* <NavBar /> */}
      <Head>
        <title>Daftar Cloudbank reseller sekarang juga - CloudBank</title>
        <link rel="canonical" href="https://www.cloudbank.id/reseller" />
      </Head>
      <HeaderPartner
        title={headerTitle}
        description={headerDescription}
        button="reseller"
      />
      <div className="d-flex flex-column my-5">
        <WhyJoinReseller />
        <TablePriceReseller />

        <FormPartner
          title={title}
          paragraf={description}
          type={1}
          idMobile="resellerMobile"
          idDesktop="resellerDesktop"
        />
        <CallMe />
      </div>

      <FooterCloud />
    </div>
  );
};

export default Reseller;
